import { GenericUser } from '@/react/types'

export const fullUsername = (user: GenericUser | null): string => {
  if (!user) return ''
  if (user.first_name && !user.last_name) return user.first_name
  if (user.last_name && !user.first_name) return user.last_name
  return user.first_name + ' ' + user.last_name
}
